/**
 * Header.js
 * Created by calhosh on 11/10/2020.
 */

import React from 'react';
import DocumentName from '../../Common/DocumentName/DocumentName';
import {entityTypes} from '../../../util/uiconstants';

const RenderDocumentHeaderWithParentName = function(props) {
	const {document} = props;
	return (
		<DocumentName
			engagementId={document.engagementId}
			documentName={document.documentName}
			documentTypeId={document.documentTypeId}
			fileExt={document.fileExt}
			isReturned={document.isReturned}
			isReadOnly={document.isReadOnly}
			isEPSignoffRequired={document.isEPSignoffRequired}
			isEPSignoffUserRequired={document.isEPSignoffUserRequired}
			isEQRSignoffRequired={document.isEQRSignoffRequired}
			isEQRSignoffUserRequired={document.isEQRSignoffUserRequired}
			size="small"
			isShared={document.isShared}
			showShared={document.isShared}
			documentId={document.id}
			enableOpenDocument
		/>
	);
};
const RenderTaskBadgeAndName = function(props) {
	return <section>task name</section>;
};

const Header = function(props) {
	switch (props.entityType) {
		case entityTypes.Document:
			return <RenderDocumentHeaderWithParentName {...props} />;
		case entityTypes.Task:
			return <RenderTaskBadgeAndName {...props} />;
	}
};

export default Header;
